module.exports = __webpack_public_path__ + "static/media/expense.342b0a19.png";